/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface EventValidator
 */
export interface EventValidator {
    /**
     * The ID of the event type this mapping is associated with
     * @type {string}
     * @memberof EventValidator
     */
    eventTypeId: string;
    /**
     * JSON Logic conditions to evaluate against the event's own fields
     * @type {object}
     * @memberof EventValidator
     */
    jsonValidator?: object;
    /**
     * JSON Logic conditions to evaluate against user's current state (game mode, map, etc.)
     * @type {object}
     * @memberof EventValidator
     */
    contextValidator?: object;
    /**
     * 
     * @type {string}
     * @memberof EventValidator
     */
    photoType?: string;
}

/**
 * Check if a given object implements the EventValidator interface.
 */
export function instanceOfEventValidator(value: object): value is EventValidator {
    if (!('eventTypeId' in value) || value['eventTypeId'] === undefined) return false;
    return true;
}

export function EventValidatorFromJSON(json: any): EventValidator {
    return EventValidatorFromJSONTyped(json, false);
}

export function EventValidatorFromJSONTyped(json: any, ignoreDiscriminator: boolean): EventValidator {
    if (json == null) {
        return json;
    }
    return {
        
        'eventTypeId': json['eventTypeId'],
        'jsonValidator': json['jsonValidator'] == null ? undefined : json['jsonValidator'],
        'contextValidator': json['contextValidator'] == null ? undefined : json['contextValidator'],
        'photoType': json['photoType'] == null ? undefined : json['photoType'],
    };
}

export function EventValidatorToJSON(json: any): EventValidator {
    return EventValidatorToJSONTyped(json, false);
}

export function EventValidatorToJSONTyped(value?: EventValidator | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'eventTypeId': value['eventTypeId'],
        'jsonValidator': value['jsonValidator'],
        'contextValidator': value['contextValidator'],
        'photoType': value['photoType'],
    };
}

